
import '../../frontend-js-codemirror-web/__liferay__/exports/codemirror$lib$codemirror.css.js';
